export default "__VITE_ASSET__5bd2cf15__"